/* eslint-disable camelcase */
import { RegularService } from '../../models';
import { GET_REGULAR_SERVICES } from '../constants/regularServicesList';

const convertService = (service) => {
  const { id, name, typ, price, price_with_fee } = service;
  return new RegularService(id, name, typ, price, price_with_fee);
};
const convertServices = (services) => {
  return services.map((service) => {
    return convertService(service);
  });
};

// eslint-disable-next-line import/prefer-default-export
export const getRegularServices = (workshopId, regularServices) => {
  const convertedRegularServices = regularServices.reduce((result, data) => {
    const convertedServicesForType = convertServices(data.services);
    const typ = data?.typ;
    /* eslint-disable no-param-reassign */
    result[typ] = convertedServicesForType;
    return result;
  }, {});

  return (dispatch) => {
    dispatch({
      type: GET_REGULAR_SERVICES,
      workshopId,
      regularServices: convertedRegularServices,
    });
  };
};
